// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../../../types';

export default styled<any, Theme>('span')`
  color: ${props => props.theme.languageSelector.labelColor};
  margin-left: .5em;
  white-space: nowrap;
`;
